import type { ReactNode } from 'react';
import { useWidgetContainerStyles } from './WidgetContainer.styles';

interface WidgetContainerProps {
  title: string;
  children: ReactNode;
}

export function WidgetContainer({ title, children }: WidgetContainerProps) {
  const styles = useWidgetContainerStyles();

  return (
    <section className={styles.root} aria-label={title}>
      <h2 className={styles.title}>{title}</h2>
      <div className={styles.content}>{children}</div>
    </section>
  );
}
